import { useState } from "react";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";

const WordCounter = () => {
  const [text, setText] = useState("");

  const countWords = (str) => {
    if (!str.trim()) return 0;
    return str.trim().split(/\s+/).length;
  };

  const countCharacters = (str) => {
    return str.length;
  };

  const countLines = (str) => {
    if (!str) return 0;
    return str.split("\n").length;
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  return (
    <>
      <HeaderSection toolId="wordCount" />
      <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4 dark:text-white">
        <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
            <h1 className="text-2xl font-bold mb-2 flex items-center">
              <FontAwesomeIcon icon={faAlignLeft} className="mr-3" />
              Word Counter
            </h1>
            <p className="opacity-90">
              Count words, characters, and lines in your text
            </p>
          </div>

          <div className="p-6 border-b border-gray-200 dark:border-gray-700">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
              htmlFor="text"
            >
              Text Input
            </label>
            <textarea
              id="text"
              value={text}
              onChange={handleTextChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Enter your text here..."
              rows={8}
              spellCheck="false"
            />
          </div>

          <div className="p-6">
            <div className="grid grid-cols-3 gap-4 text-center">
              <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-md shadow-sm">
                <div className="text-sm text-gray-600 dark:text-gray-300">Words</div>
                <div className="text-2xl font-bold dark:text-white">{countWords(text)}</div>
              </div>
              <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-md shadow-sm">
                <div className="text-sm text-gray-600 dark:text-gray-300">Characters</div>
                <div className="text-2xl font-bold dark:text-white">{countCharacters(text)}</div>
              </div>
              <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-md shadow-sm">
                <div className="text-sm text-gray-600 dark:text-gray-300">Lines</div>
                <div className="text-2xl font-bold dark:text-white">{countLines(text)}</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 dark:bg-gray-700 p-6">
            <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-3">
              About Word Counter
            </h2>
            <p className="text-gray-600 dark:text-gray-300 text-sm">
              This tool counts words (separated by whitespace), characters (including spaces),
              and lines in your text. Useful for writers, students, and content creators
              who need to meet specific length requirements.
            </p>
          </div>
        </div>
      </div>
      <BottomSection toolId="wordCount" />
    </>
  );
};

export default WordCounter;